import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FilterValue } from 'src/app/classes/filter-value';
import { ElementAttribute } from 'src/app/enums/element-attribute';
import { FilterValueType } from 'src/app/enums/filter-value-type';
import { RestApiEndpoints } from 'src/app/enums/rest-api-endpoints';
import { CredentialsService } from 'src/app/services/credentials.service';
import { FileService } from 'src/app/services/file.service';
import { RestApiService } from 'src/app/services/rest-api.service';

declare function cleanInput(inputString: string, shouldURLEncode: boolean): string;
declare function makeToast(message: string): void;
declare function openModalWithID(modalID: string): void;
declare function closeModalWithID(modalID: string): void;
declare function initBurialsApplicationValues(): void;
declare function initToolTip(): void;

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.css']
})
export class DocumentsComponent {

  entryId?: string;
  isLoading: boolean = false;
  files: any = [];
  selectedFiles: any = [];
  selectedFile: any;
  contentx: any;
  filterValues: FilterValue[] = [];

  constructor(private activatedRoute: ActivatedRoute,
    private restApiService: RestApiService,
    private fileService: FileService,
    private credentialsService: CredentialsService) {

    if (activatedRoute.snapshot.paramMap.has('id')) {
      this.entryId = activatedRoute.snapshot.paramMap.get('id') as string;
    }

  }

  ngAfterViewInit() {
    initToolTip();
    setTimeout(() => this.reloadData(), 1);
  }

  loadMoreButtonClicked() {
    this.reloadData(true);
  }

  reloadData(isLoadMore: boolean = false) {
    if (!this.entryId) { return; }

    if (!isLoadMore) {
      this.files = [];
    }

    this.selectedFiles = [];
    this.selectedFile = null;
    this.contentx = null;

    var rolle_admin = '0';

    const bestatter = localStorage.getItem('bestatter');
    if (bestatter) {
      var tmpBestatter = JSON.parse(bestatter);
      if (tmpBestatter && tmpBestatter.hasOwnProperty('rolle_admin') && tmpBestatter.rolle_admin) {
        rolle_admin = tmpBestatter.rolle_admin;
      }
    }

    var postBody: any = {
      burialnumber: cleanInput(this.entryId, true),
      rolle_admin: cleanInput(rolle_admin, true)
    };

    const requestEndpoint = this.entryId == 'all' ? RestApiEndpoints.archiveAll : RestApiEndpoints.archive

    if (this.entryId == 'all') {
      postBody.offset = this.files.length;

      this.filterValues.forEach(filterValue => {
        switch (filterValue.type) {
          case FilterValueType.startDate:
            postBody.startDate = filterValue.value;
            break;
          case FilterValueType.endDate:
            postBody.endDate = filterValue.value;
            break;
          case FilterValueType.invoiceNumber:
            postBody.invoiceNumber = filterValue.value;
            break;
        }
      });
    }

    this.isLoading = true;
    this.restApiService.sendAsyncRequestToEndpoint(requestEndpoint, postBody, (success, response) => {
      this.isLoading = false;
      initToolTip();

      if (!success || !response || !response.success || !response.payload) {
        makeToast('Abfrage fehlgeschlagen');
        return;
      }

      for (const payloadDocument of response.payload) {
        this.files.push(payloadDocument);
      }

      for (let index = 0; index < this.files.length; index++) {
        this.selectedFiles.push(index);
      }
    });
  }

  navigateBack() {
    window.close();
  }

  download() {
    this.downloadSelectedFilesFromIndex(0);
  }

  private downloadSelectedFilesFromIndex(index: number) {
    setTimeout(() => {
      const selectedFileIndex = this.selectedFiles[index];
      this.downloadFile(this.files[selectedFileIndex]);

      if (!this.selectedFiles[index + 1]) { return; }

      this.downloadSelectedFilesFromIndex(index + 1);
    }, index == 0 ? 0 : 500);
  }

  private downloadFile(file: any) {
    if (!file) { return; }
    const blobUrl = this.fileService.createBlobUrlFromBaseString(file.dok_base64, 'application/pdf');
    const tmpDownloadElement = document.createElement('a');
    tmpDownloadElement.id = new Date().getMilliseconds() + '_download';
    tmpDownloadElement.href = blobUrl;
    tmpDownloadElement.download = file.beleg_nr ? file.beleg_typ + '_' + file.beleg_nr + '.pdf' : file.beleg_typ + '.pdf';
    document.body.appendChild(tmpDownloadElement);
    tmpDownloadElement.click();
    document.body.removeChild(tmpDownloadElement);
  }

  openPdfAtIndex(index: number) {
    this.selectedFile = this.files[index];
    openModalWithID('filedetailmodal');
  }

  closeModal() {
    closeModalWithID('filedetailmodal');
  }

  downloadSingleFileAtIndex(index: number) {
    const selectedFileIndex = this.selectedFiles[index];
    this.downloadFile(this.files[selectedFileIndex]);
  }

  filterButtonClicked() {
    openModalWithID('filtermodal');
    initBurialsApplicationValues();
  }

  addFilterValue(fieldId: string) {
    if (!fieldId) { return; }

    const inputField = this.credentialsService.parseElementBy(ElementAttribute.id, fieldId);
    const value = inputField.value;

    let intendedFilterValueType: FilterValueType | null = null;

    if (fieldId == 'inputFilterStart') {
      intendedFilterValueType = FilterValueType.startDate;
    } else if (fieldId == 'inputFilterEnd') {
      intendedFilterValueType = FilterValueType.endDate;
    } else if (fieldId == 'inputFilterInvoiceNumber') {
      intendedFilterValueType = FilterValueType.invoiceNumber;
    }

    if (!value || !intendedFilterValueType) { return; }

    const newFilterValues: FilterValue[] = [];
    const filterValuesNotMatchingCurrentType = this.filterValues.filter(filterValue => { return filterValue.type != intendedFilterValueType; });

    filterValuesNotMatchingCurrentType.forEach(filterValueNotMatchingCurrentType => {
      newFilterValues.push(filterValueNotMatchingCurrentType);
    });

    newFilterValues.push(new FilterValue(value, intendedFilterValueType));

    inputField.value = null;

    this.filterValues = newFilterValues;
  }

  deleteFilterValue(filterValue: FilterValue) {
    this.filterValues = this.filterValues.filter(compareFilterValue => { return compareFilterValue.value != filterValue.value || compareFilterValue.type != filterValue.type; })
  }

  deleteAllFilters() {
    this.filterValues = [];
  }

  useFilterButtonClicked() {
    this.addFilterValue('inputFilterStart');
    this.addFilterValue('inputFilterEnd');

    closeModalWithID('filtermodal');

    this.reloadData();
  }

}
